const Api = {
    '/api/order/export': 1, // 订单导出
    '/api/sample-order/import' : 1, // 样品订单导入
    '/api/team-anchor/batch-allot': 1, //批量导入
    '/api/ranking/export': 1, // 排行榜导出
    '/api/partner-result/employees-list-export': 1, //业绩管理导出
    '/api/stat/export-talent-achievement': 1, //业绩管理导出
    '/api/talent/export': 1, // 我的达人导出
    '/api/team-sea/export': 1, // 团队公海导出
    '/api/product-info/export': 1, // 商品库导出
    '/api/sample-order/export-sample-list': 1, //样品订单导出
    '/api/talent/batch-add': 1, // 我的达人快手批量导入
}

export default{
    Api
}